import { Component, OnInit } from '@angular/core';
import { ApiService } from './api.service';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(public api:ApiService, private config: PrimeNGConfig, private translate: TranslateService) { 

  }

  ngOnInit() {
    this.translate.addLangs(['en-US', 'fr-FR']);
    if(this.api.export){
      this.translate.use('en-US');
    }else{
      this.translate.use('fr-FR');
    }
    this.translate.get('primeng').subscribe(res => this.config.setTranslation(res)); 
  }

}
